// extracted by mini-css-extract-plugin
module.exports = {"hero":"PageHero-module--hero--koCC2","caption":"PageHero-module--caption--YsiRz"};